export default __webpack_public_path__ + "static/media/navbar-balance-dark.cb7da410.svg";